import React, { useEffect, useState } from "react";
import HiddenDataTable from "../../../../../../components/HiddenDataTable";
import style from "./style.module.scss";
import ButtonIcon from "../../../../../../components/ButtonIcon/ButtonIcon";
import Filter from "../../../../../../assets/svg/icons/common/Filter";
import Download from "../../../../../../assets/svg/icons/common/Download";
import BatchDataTable from "./BatchDataTable/Index";
import { GetBatchData } from "../../../../../../../api";
import MonthPicker from "../../../../../../components/MonthPicker/Index";
import { getFullMonthName } from "../../../../../../../components/helper/helper";
import useMerchantStore from "../../../../../../stores/merchant";
import useCommonStore from "../../../../../../stores/common";

function BatchData() {
  const expandDetails = useCommonStore((state) => state.expandDetails);
  const activeApp = useMerchantStore((state) => state.activeApp);
  const [batchData, setBatchData] = useState([]);
  const [year, setYear] = useState(null);
  const [month, setMonth] = useState(null);

  const fetchData = async () => {
    const response = await GetBatchData({
      powerapp_id: activeApp?.id,
      month: month,
      year: year,
    });
    if (response?.status) {
      setBatchData(response.data);
    }
  };

  useEffect(() => {
    fetchData();
  }, [activeApp?.id, month, year]);

  const onChangeFilter = (data) => {
    setYear(data.year);
    setMonth(getFullMonthName(data.month));
  };

  return (
    <>
      {!expandDetails && (
        <div className={style.container}>
          <HiddenDataTable />
        </div>
      )}

      {expandDetails && (
        <div className={style.container}>
          <header className={style.header}>
            <div className={style.left}>
              <h5>Batch Data</h5>
              <ButtonIcon textColor="#254FE2">Expand All</ButtonIcon>
            </div>
            <div className={style.right}>
              <MonthPicker
                text={<Filter />}
                submitText="Apply"
                onSubmit={(data) => onChangeFilter(data)}
              />

              <ButtonIcon bgColor={"#EDEDF4"}>
                <Download />
                <span>Download</span>
              </ButtonIcon>
            </div>
          </header>

          <div className={style.body}>
            <BatchDataTable data={batchData} />
          </div>

          <footer className={style.footer}>{/* <Pagination /> */}</footer>
        </div>
      )}
    </>
  );
}

export default BatchData;
